import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { Box, Typography, Paper, Chip, Button } from "@mui/material";
import { data, useNavigate } from "react-router-dom";
import CustomSearchBar from "../Lease Module/CustomSearchBar";
import FormsBottomNavbar from "./../Post Module/FormsBottomNavbar";
import { BASE_URL } from "../../Api/ApiUrls";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import Jvjd_BankAuctionReusableCard from "./Jvjd_BankAuctionReusableCard";
import GuestLoginModal from "../../GuestLoginModal";

// Fix Leaflet default icon issue
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { AuthContext } from "../../AuthContext/AuthContext";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const REQUEST_API = `${BASE_URL}/properties/filter/`;
const TYPES = ["JV/JD", "BUILD TO SUIT"];
const PROPERTY_TYPES = ["PLOT", "LAND"];

const normalizeLookingFor = (value) => {
  if (!value) return null;
  const v = value.toLowerCase();
  if (v === "jv/jd") return "JV/JD";
  if (v === "build to suit") return "BUILD TO SUIT";
  return null;
};

const JDJV = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState("JV/JD");
  const [selectedPropertyType, setSelectedPropertyType] = useState(null);
  const [requests, setRequests] = useState([]);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [visibleRequests, setVisibleRequests] = useState([]);
  const [visibleProperties, setVisibleProperties] = useState([]);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const [map, setMap] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [markers, setMarkers] = useState([]);
  const [activeParentReqId, setActiveParentReqId] = useState(null);
  const [currentBounds, setCurrentBounds] = useState(null);
  const [mapKey, setMapKey] = useState(0);
  const [searchLocation, setSearchLocation] = useState(null);
  const [priceFilter, setPriceFilter] = useState(null);
  const [currentZoom, setCurrentZoom] = useState(11);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
const [isLoading, setIsLoading] = useState(true);

  const mapContainerRef = useRef(null);
  const cardListRef = useRef(null);
  const skipMapPanRef = useRef(false);
  const isProgrammaticScrollRef = useRef(false);
  const scrollTimeoutRef = useRef(null);
  const scrollDebounceRef = useRef(null);
  const lastActiveIdRef = useRef(null);
  const isPointerOverCarouselRef = useRef(false);
  const hasInitializedRef = useRef(false);
  const searchLocationMarkerRef = useRef(null);
  const searchCircleRef = useRef(null);
  
    const { isGuest } = useContext(AuthContext);
      const [showGuestModal, setShowGuestModal] = useState(false);

  const disableMapInteractions = () => {
    if (!map) return;
    try {
      map.dragging?.enabled() && map.dragging.disable();
      map.touchZoom?.enabled() && map.touchZoom.disable();
      map.doubleClickZoom?.enabled() && map.doubleClickZoom.disable();
      map.scrollWheelZoom?.enabled() && map.scrollWheelZoom.disable();
    } catch (err) {}
  };

  const enableMapInteractions = () => {
    if (!map) return;
    try {
      !map.dragging?.enabled() && map.dragging.enable();
      !map.touchZoom?.enabled() && map.touchZoom.enable();
      !map.doubleClickZoom?.enabled() && map.doubleClickZoom.enable();
      !map.scrollWheelZoom?.enabled() && map.scrollWheelZoom.enable();
    } catch (err) {}
  };

  useEffect(() => {
    const container = cardListRef.current;
    if (!container) return;

    const onPointerDown = () => {
      isPointerOverCarouselRef.current = true;
      disableMapInteractions();
    };
    const onPointerUpOrCancel = () => {
      isPointerOverCarouselRef.current = false;
      setTimeout(enableMapInteractions, 40);
    };

    container.addEventListener('pointerdown', onPointerDown, { passive: true });
    window.addEventListener('pointerup', onPointerUpOrCancel, { passive: true });
    container.addEventListener('pointercancel', onPointerUpOrCancel, { passive: true });
    container.addEventListener('touchcancel', onPointerUpOrCancel, { passive: true });

    return () => {
      container.removeEventListener('pointerdown', onPointerDown);
      window.removeEventListener('pointerup', onPointerUpOrCancel);
      container.removeEventListener('pointercancel', onPointerUpOrCancel);
      container.removeEventListener('touchcancel', onPointerUpOrCancel);
    };
  }, [map]);

useEffect(() => {
  const fetchRequests = async () => {
    try {
      setIsLoading(true);


      const res = await fetch(`${BASE_URL}/properties/filter/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      body: JSON.stringify({
  include: {
    type: selectedType.toLowerCase(),  
    Admin_status: "Approved",
  },
  exclude: {},
}),
      });
const responseData = await res.json();

// ✅ Ensure it's always an array
const list = Array.isArray(responseData)
  ? responseData
  : responseData.data || responseData.results || [];

const parsed = list
  .filter((item) => {
          const lookingFor = normalizeLookingFor(item.type);
          return lookingFor && item.lat && item.long;
        })
        .map((item) => {
          const lat = item.lat ? parseFloat(item.lat) : null;
          const lng = item.long ? parseFloat(item.long) : null;

          return {
            id: String(item.property_id),
            parentReqId: String(item.property_id),
            req_id: item.property_id,
            looking_for: normalizeLookingFor(item.type),
            property_type: (item.property_type || "").toUpperCase(),
            price: item.min_budget,
            max_budget: item.max_budget,
            location_name: item.location,
            lat,
            lng,
            description: item.description,
            originalItem: item,
          };
        })
        .filter(
          (item) =>
            item.lat !== null &&
            item.lng !== null &&
            !isNaN(item.lat) &&
            !isNaN(item.lng)
        );

      setRequests(parsed);
      setFilteredRequests(parsed);

      if (parsed.length > 0 && isInitialLoad) {
        setActiveParentReqId(parsed[0].parentReqId);
        setIsInitialLoad(false);
      }
    } catch (e) {
      console.error("API error", e);
    } finally {
      setIsLoading(false); // ✅ stop loading
    }
  };

  fetchRequests();
}, [selectedType]);

  // Apply filters
  useEffect(() => {
    let filtered = requests.filter(r => r.looking_for === selectedType);

    if (selectedPropertyType) {
      filtered = filtered.filter(r => r.property_type === selectedPropertyType);
    }

    if (priceFilter) {
      filtered = filtered.filter(property => {
        const price = property.price || 0;
        const numericPrice = Number(price);
        if (priceFilter.min === 0 && priceFilter.max === 0) return true;
        if (priceFilter.max === Infinity) return numericPrice >= priceFilter.min;
        return numericPrice >= priceFilter.min && numericPrice <= priceFilter.max;
      });
    }

    if (searchLocation) {
      const centerLat = searchLocation.lat;
      const centerLng = searchLocation.lng;
      filtered = filtered
        .map(prop => {
          if (!prop.lat || !prop.lng) return prop;
          const distance = L.latLng([prop.lat, prop.lng]).distanceTo([centerLat, centerLng]);
          return { ...prop, distance };
        })
        .sort((a, b) => (a.distance || Infinity) - (b.distance || Infinity));
    }

    setFilteredRequests(filtered);
    if (cardListRef.current) cardListRef.current.scrollLeft = 0;
    
    // Reset active property when filters change
    if (filtered.length > 0) {
      setActiveParentReqId(filtered[0].parentReqId);
    } else {
      setActiveParentReqId(null);
    }
    
    hasInitializedRef.current = false;
    lastActiveIdRef.current = null;
  }, [requests, selectedType, selectedPropertyType, priceFilter, searchLocation]);

  const getPriceLabel = (price) => {
    const num = Number(price || 0);
    if (num >= 10000000) return `${Math.round(num / 10000000)} Cr`;
    if (num >= 100000) return `${Math.round(num / 100000)} L`;
    if (num >= 1000) return `${Math.round(num / 1000)} K`;
    return `${num}`;
  };

const createMarkerIconForProperty = (request, isActive = false) => {
  try {
    const color = isActive ? "#000000" : "#008000";
    const borderColor = isActive ? "#FF0000" : "#FFFFFF";

    const showPriceLabel = currentZoom >= 12;

    // 🔽 reduced base sizes
    const baseSize = showPriceLabel ? 24 : 14;

    // 🔽 reduced active scale
    const scale = isActive ? 1.18 : 1;

    const size = Math.round(baseSize * scale);
    const priceText = getPriceLabel(request.price);

    return L.divIcon({
      className: "custom-marker",
      html: `
        <div style="
          width: ${size}px;
          height: ${size}px;
          border-radius: 50%;
          background-color: ${color};
          border: 2px solid ${borderColor};
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 1px 3px rgba(0,0,0,0.25);
          overflow: hidden;
        ">
          ${
            showPriceLabel
              ? `
            <span style="
              color: #ffffff;
              font-size: ${Math.max(7, size * 0.36)}px;
              font-weight: 500;
              white-space: nowrap;
              line-height: 1;
            ">
              ${priceText}
            </span>
          `
              : ""
          }
        </div>
      `,
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
    });
  } catch (err) {
    return L.divIcon({ className: "custom-marker" });
  }
};



  // Map initialization
  useEffect(() => {
    if (!mapContainerRef.current || mapContainerRef.current._leaflet_id) return;

    let initialCenter = [17.385, 78.486]; // Hyderabad default
    let initialZoom = 11;
    
    const leafletMap = L.map(mapContainerRef.current, {
      center: initialCenter,
      zoom: initialZoom,
      zoomControl: false,
      maxZoom: 20,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; OpenStreetMap contributors',
      maxNativeZoom: 20
    }).addTo(leafletMap);

    L.control.zoom({ position: "topright" }).addTo(leafletMap);

    const handleMoveEnd = () => {
      setCurrentBounds(leafletMap.getBounds());
      setCurrentZoom(leafletMap.getZoom());
    };
    
    const handleZoomEnd = () => {
      setCurrentBounds(leafletMap.getBounds());
      setCurrentZoom(leafletMap.getZoom());
    };

    leafletMap.on("moveend", handleMoveEnd);
    leafletMap.on("zoomend", handleZoomEnd);

    setMap(leafletMap);
    setMapLoaded(true);
    setCurrentBounds(leafletMap.getBounds());
    setCurrentZoom(leafletMap.getZoom());

    return () => {
      leafletMap.off("moveend", handleMoveEnd);
      leafletMap.off("zoomend", handleZoomEnd);
      leafletMap.eachLayer(layer => { try { leafletMap.removeLayer(layer); } catch {} });
      leafletMap.remove();
      setMap(null);
      setMapLoaded(false);
      setMarkers([]);
      setCurrentZoom(11);
    };
  }, [mapKey]);

useEffect(() => {
  if (!map || !mapLoaded) return;
  
  const handleSearchLocation = () => {
    if (!searchLocation) {
      // Clear search markers if no search location
      if (searchLocationMarkerRef.current && map.hasLayer(searchLocationMarkerRef.current)) {
        map.removeLayer(searchLocationMarkerRef.current);
        searchLocationMarkerRef.current = null;
      }
      if (searchCircleRef.current && map.hasLayer(searchCircleRef.current)) {
        map.removeLayer(searchCircleRef.current);
        searchCircleRef.current = null;
      }
      return;
    }

    try {
      const { lat, lng } = searchLocation;
      
      // Validate coordinates
      if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
        console.error('Invalid search location coordinates:', searchLocation);
        return;
      }

      console.log('Centering map to search location:', { lat, lng });
      
      map.setView([lat, lng], 13, { 
        animate: true,
        duration: 1,
        easeLinearity: 0.25
      });

      if (searchLocationMarkerRef.current && map.hasLayer(searchLocationMarkerRef.current)) {
        map.removeLayer(searchLocationMarkerRef.current);
        searchLocationMarkerRef.current = null;
      }
      if (searchCircleRef.current && map.hasLayer(searchCircleRef.current)) {
        map.removeLayer(searchCircleRef.current);
        searchCircleRef.current = null;
      }

      // Ensure search location is in view (no marker added)
      setTimeout(() => {
        if (map && map.getCenter().distanceTo([lat, lng]) > 100) {
          map.panTo([lat, lng], { animate: true });
        }
      }, 300);

    } catch (error) {
      console.error('Error handling search location:', error);
    }
  };

  // Use a timeout to ensure map is ready
  const timer = setTimeout(() => {
    handleSearchLocation();
  }, 100);

  return () => clearTimeout(timer);
}, [searchLocation, map, mapLoaded]);

useEffect(() => {
  if (!currentBounds) {
    setVisibleRequests(filteredRequests);
    setVisibleProperties([]);
    return;
  }

  const inBounds = filteredRequests.filter(p =>
    p.lat && p.lng && currentBounds.contains(L.latLng([p.lat, p.lng]))
  );

  setVisibleRequests(inBounds);

  if (inBounds.length === 0) {
    setVisibleProperties([]);
    return;
  }

  const uniqueProperties = [];
  const seenReqIds = new Set();
  inBounds.forEach(req => {
    if (!seenReqIds.has(req.parentReqId)) {
      seenReqIds.add(req.parentReqId);
      uniqueProperties.push({
        ...req,
        property_id: req.req_id,
        property_name: req.location_name || "Property",
        min_budget: req.price,
        max_budget: req.max_budget,
        location: req.location_name,
        property_type: req.property_type,
        looking_for: req.looking_for,
        area: req.area,
        units: req.units,
        ratio: req.ratio,
        min_acres: req.min_acres,
        max_acres: req.max_acres,
        posted_by: req.posted_by,
        roadwidth: req.roadwidth,
        facing: req.facing,
        description: req.description,
        lat: req.lat,
        lng: req.lng,
        fullData: req.originalItem,
      });
    }
  });

  const arrangeByNearestNeighbor = (properties) => {
    if (properties.length <= 1) return properties;
    
    const result = [properties[0]];
    const remaining = [...properties.slice(1)];
    
    while (remaining.length > 0) {
      const lastProperty = result[result.length - 1];
      const lastLocation = L.latLng(lastProperty.lat, lastProperty.lng);
      
      let nearestIndex = 0;
      let nearestDistance = L.latLng([remaining[0].lat, remaining[0].lng])
        .distanceTo(lastLocation);
      
      for (let i = 1; i < remaining.length; i++) {
        const distance = L.latLng([remaining[i].lat, remaining[i].lng])
          .distanceTo(lastLocation);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = i;
        }
      }
      
      result.push(remaining[nearestIndex]);
      remaining.splice(nearestIndex, 1);
    }
    
    return result;
  };

  const arrangedProperties = arrangeByNearestNeighbor(uniqueProperties);
  
  setVisibleProperties(arrangedProperties);

  if (arrangedProperties.length > 0) {
    const isActiveInView = arrangedProperties.find(p => p.parentReqId === activeParentReqId);
    if (!isActiveInView) {
      setActiveParentReqId(arrangedProperties[0].parentReqId);
    }
  }
}, [currentBounds, filteredRequests, activeParentReqId]);

  useEffect(() => {
    if (!map || !mapLoaded || filteredRequests.length === 0) return;

    markers.forEach(m => { try { map.hasLayer(m) && map.removeLayer(m); } catch {} });

    const newMarkers = filteredRequests.map(req => {
      const isActive = activeParentReqId && req.parentReqId === activeParentReqId;
      const icon = createMarkerIconForProperty(req, isActive);

      const marker = L.marker([req.lat, req.lng], {
        icon,
        propertyId: req.id,
        parentReqId: req.parentReqId,
      }).addTo(map);

      marker.on('click', () => {
        skipMapPanRef.current = true;
        setActiveParentReqId(req.parentReqId);
        setTimeout(() => {
          scrollToCard(req.parentReqId);
          setTimeout(() => { skipMapPanRef.current = false; }, 500);
        }, 50);
      });

      if (isActive) marker.setZIndexOffset(1000);

      return marker;
    });

    setMarkers(newMarkers);

    if (filteredRequests.length > 0 && !searchLocation) {
      const coords = filteredRequests.map(p => [p.lat, p.lng]);
      if (coords.length > 0) {
        const bounds = L.latLngBounds(coords);
        map.fitBounds(bounds, { padding: [50, 50], maxZoom: 5, animate: true });
      }
    }
    hasInitializedRef.current = true;
  }, [filteredRequests, map, mapLoaded, searchLocation]);

  useEffect(() => {
    if (!map || !markers.length || !hasInitializedRef.current) return;

    markers.forEach(m => {
      const req = filteredRequests.find(r => r.id === m.options.propertyId);
      if (req) {
        const isActive = activeParentReqId && req.parentReqId === activeParentReqId;
        m.setIcon(createMarkerIconForProperty(req, isActive));
        m.setZIndexOffset(isActive ? 1000 : 0);
      }
    });

    if (!skipMapPanRef.current && map && activeParentReqId) {
      const activeReqs = filteredRequests.filter(r => r.parentReqId === activeParentReqId);
      if (activeReqs.length > 0) {
        map.panTo([activeReqs[0].lat, activeReqs[0].lng], { animate: true, duration: 0.4 });
      }
    }
  }, [activeParentReqId, markers, map, filteredRequests, currentZoom]);

  const scrollToCard = (propertyId) => {
    const container = cardListRef.current;
    if (!container) return;
    const el = container.querySelector(`[data-property-id="${propertyId}"]`);
    if (el) {
      isProgrammaticScrollRef.current = true;
      el.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = setTimeout(() => { isProgrammaticScrollRef.current = false; }, 450);
    }
  };

  useEffect(() => {
    const container = cardListRef.current;
    if (!container || visibleProperties.length === 0) return;

    const onScroll = () => {
      if (isProgrammaticScrollRef.current) return;
      if (scrollDebounceRef.current) clearTimeout(scrollDebounceRef.current);

      scrollDebounceRef.current = setTimeout(() => {
        const rect = container.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const cards = Array.from(container.querySelectorAll('[data-property-id]'));
        if (!cards.length) return;

        let closest = null;
        let closestDistance = Infinity;

        cards.forEach(card => {
          const cRect = card.getBoundingClientRect();
          const cardCenter = cRect.left + cRect.width / 2;
          const distance = Math.abs(cardCenter - centerX);
          if (distance < closestDistance) {
            closestDistance = distance;
            closest = card;
          }
        });

        if (closest) {
          const id = closest.getAttribute('data-property-id');
          if (id && id !== lastActiveIdRef.current) {
            setActiveParentReqId(id);
            lastActiveIdRef.current = id;
          }
        }
      }, 150);
    };

    // Don't activate immediately on load
    if (!hasInitializedRef.current) {
      const timeoutId = setTimeout(() => {
        hasInitializedRef.current = true;
        container.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        
        if (visibleProperties.length > 0 && !activeParentReqId) {
          setActiveParentReqId(visibleProperties[0].parentReqId);
        }
      }, 800); 
      
      return () => {
        clearTimeout(timeoutId);
        container.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        clearTimeout(scrollTimeoutRef.current);
        clearTimeout(scrollDebounceRef.current);
      };
    } else {
      container.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      
      return () => {
        container.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        clearTimeout(scrollTimeoutRef.current);
        clearTimeout(scrollDebounceRef.current);
      };
    }
  }, [visibleProperties, activeParentReqId]);

  // Carousel arrows
  useEffect(() => {
    const container = cardListRef.current;
    if (!container) return;

    const check = () => {
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      setIsAtStart(scrollLeft <= 10);
      setIsAtEnd(scrollLeft + clientWidth >= scrollWidth - 10);
    };

    container.addEventListener('scroll', check, { passive: true });
    check();

    return () => container.removeEventListener('scroll', check);
  }, [visibleProperties]);

  const handleLeftArrowClick = () => {
    const container = cardListRef.current;
    if (!container || visibleProperties.length === 0) return;
    isAtStart
      ? container.scrollTo({ left: container.scrollWidth, behavior: 'smooth' })
      : container.scrollBy({ left: -320, behavior: 'smooth' });
  };

  const handleRightArrowClick = () => {
    const container = cardListRef.current;
    if (!container || visibleProperties.length === 0) return;
    isAtEnd
      ? container.scrollTo({ left: 0, behavior: 'smooth' })
      : container.scrollBy({ left: 320, behavior: 'smooth' });
  };

  const handleSelectedLocation = (locationData) => {
    console.log('Search location selected:', locationData);
    setSearchLocation(locationData);
  };

  const clearSearch = () => {
    console.log('Clearing search...');
    setSearchLocation(null);
    setPriceFilter(null);
    setSelectedPropertyType(null);

    // Remove search location marker and circle
    if (map) {
      if (searchLocationMarkerRef.current && map.hasLayer(searchLocationMarkerRef.current)) {
        map.removeLayer(searchLocationMarkerRef.current);
        searchLocationMarkerRef.current = null;
      }
      if (searchCircleRef.current && map.hasLayer(searchCircleRef.current)) {
        map.removeLayer(searchCircleRef.current);
        searchCircleRef.current = null;
      }
      
      // Reset map view to default
      map.setView([17.385, 78.486], 5, { animate: true });
    }
    
    if (cardListRef.current) cardListRef.current.scrollLeft = 0;
    
    // Reset to first property
    if (filteredRequests.length > 0) {
      setActiveParentReqId(filteredRequests[0].parentReqId);
    } else {
      setActiveParentReqId(null);
    }
    
    hasInitializedRef.current = false;
    lastActiveIdRef.current = null;
  };

  const handlePriceFilterChange = (range) => setPriceFilter(range);

  const handleCardClick = (property) => {
  if (isGuest) {
    setShowGuestModal(true); 
    return;
  }

  navigate(
    `/jv-jv-property-detail/${property.req_id || property.property_id}`
  );
};
 
  

  return (
    <Box sx={{ maxWidth: 480, mx: "auto", bgcolor: "#EFE7DD", position: "relative" }}>
      <Box sx={{ px: 1, py: 1, position: "sticky", top: 0, zIndex: 1000, bgcolor: "#EFE7DD" }}>
        <CustomSearchBar
          onPlaceSelected={handleSelectedLocation}
          onClear={clearSearch}
          onPriceFilterChange={handlePriceFilterChange}
        />
      </Box>
<Box sx={{ px: 2 }}>
  <Typography fontWeight={600}>Looking For</Typography>
  <Box sx={{ display: "flex", gap: 1, py: 1, flexWrap: "wrap" }}>
    {/* TYPES Chips */}
    {TYPES.map((type) => (
      <Chip
        key={type}
        label={type}
        onClick={() => setSelectedType(selectedType === type ? null : type)}
        sx={{
          backgroundColor: selectedType === type ? "#000" : "transparent",
          color: selectedType === type ? "#fff" : "#000",
          border: "1px solid black",
          fontWeight: "bold",
          '&:hover': {
            backgroundColor: selectedType === type ? "#000" : "rgba(0,0,0,0.04)",
            color: selectedType === type ? "#fff" : "#000",
          }
        }}
      />
    ))}

    {/* PROPERTY_TYPES Chips */}
    {PROPERTY_TYPES.map((ptype) => (
      <Chip
        key={ptype}
        label={ptype}
        onClick={() =>
          setSelectedPropertyType(
            selectedPropertyType === ptype ? null : ptype
          )
        }
        sx={{
          backgroundColor: selectedPropertyType === ptype ? "#000" : "transparent",
          color: selectedPropertyType === ptype ? "#fff" : "#000",
          border: "1px solid black",
          fontWeight: "bold",
          '&:hover': {
            backgroundColor: selectedPropertyType === ptype ? "#000" : "rgba(0,0,0,0.04)",
            color: selectedPropertyType === ptype ? "#fff" : "#000",
          }
        }}
      />
    ))}
  </Box>
</Box>


      <Box sx={{ px: 2, pb: 10, position: "relative" }}>
        {(selectedPropertyType || priceFilter) && filteredRequests.length === 0 && (
          <Box sx={{
            position: "absolute", top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
            zIndex: 1002, width: '90%', textAlign: 'center'
          }}>
            <Box sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)', padding: '20px',
              borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', border: '1px solid rgba(0,0,0,0.1)',
            }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 'bold' }}>No properties found</Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {selectedPropertyType && `Category: "${selectedPropertyType}"`}
                {selectedPropertyType && priceFilter && ' • '}
                {priceFilter && `Price: ${priceFilter.label}`}
              </Typography>
              <Button variant="outlined" sx={{ mt: 2 }} onClick={() => { setSelectedPropertyType(null); setPriceFilter(null); }}>
                Clear Filters
              </Button>
            </Box>
          </Box>
        )}

        <div
          ref={mapContainerRef}
          key={`map-${mapKey}`}
          style={{
            width: "100vw",
            height: "calc(111vh - 302px)",
            marginLeft: "-16px",
            marginRight: "-16px",
            borderRadius: "6px",
            overflow: "hidden",
            background: "#eaeaea",
          }}
        >
          {!mapLoaded && (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <Typography>Loading map...</Typography>
            </Box>
          )}
        </div>

        {visibleProperties.length > 0 && (
          <Box sx={{
            position: "absolute", left: 0, right: 0, bottom: 72, zIndex: 1001,
            display: 'flex', alignItems: 'center', width: '100%', pointerEvents: 'auto',
          }}>
            <Button onClick={handleLeftArrowClick} sx={{
              minWidth: 0, width: 32, height: 32, p: 1, left: 5, borderRadius: '70%',
              bgcolor: 'white', boxShadow: 2, mr: 1, '&:hover': { bgcolor: 'grey.200' }, zIndex: 1002,
            }}>&lt;</Button>

            <Box
              ref={cardListRef}
              sx={{
                display: "flex", overflowX: "auto", gap: 2, flexGrow: 1,
                scrollSnapType: "x mandatory", scrollbarWidth: "none",
                msOverflowStyle: "none", "&::-webkit-scrollbar": { display: "none" },
              }}
            >
              {visibleProperties.map((prop) => (
                <Box
                  key={`${prop.id}-${prop.loc_id}`}
                  data-property-id={prop.parentReqId}
                  sx={{ 
                    flex: "0 0 280px", 
                    scrollSnapAlign: "center", 
                    cursor: "pointer", 
                    height: "130px",
                    borderRadius: "4px",
                    transition: "border 0.2s ease"
                  }}
                  onClick={() => handleCardClick(prop)}
                >
                  <div style={{ padding: 0, height: '100%' }}>
                    <Jvjd_BankAuctionReusableCard property={prop} onCardClick={() => handleCardClick(prop)} />
                  </div>
                </Box>
              ))}
            </Box>

            <Button onClick={handleRightArrowClick} sx={{
              minWidth: 0, width: 32, height: 32, borderRadius: '50%', bgcolor: 'white',
              boxShadow: 2, p: 1, right: 5, ml: 1, '&:hover': { bgcolor: 'grey.200' }, zIndex: 1002,
            }}>&gt;</Button>
          </Box>
        )}

        {visibleProperties.length === 0 && filteredRequests.length > 0 && (
          <Box sx={{
            position: "absolute", bottom: 10, left: "50%", transform: "translateX(-50%)",
            zIndex: 1001, backgroundColor: "rgba(255,255,255,0.9)", padding: "8px 16px",
            borderRadius: "4px", boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
          }}>
            <Typography variant="body2">
              No properties in current view. Zoom or pan to see properties.
            </Typography>
          </Box>
        )}
      </Box>
      
            <GuestLoginModal
        open={showGuestModal}
        onClose={() => setShowGuestModal(false)}
      />

      <Paper sx={{ position: "fixed", bottom: 0, left: 0, right: 0 }}>
        <FormsBottomNavbar />
      </Paper>
    </Box>
  );
};

export default JDJV;